import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { localePath } from "../i18n/config";

import { clearUserError, registerCustomerRequest } from "../redux/actions";
import { AppState } from "../redux/types";
import { CATEGORIES, categoryOptions, formatRegionOption, REGIONS, ROLE } from "../utils/constants";
import Message from "./Message";
import InfoAccordion from "./infoAccordion/InfoAccordion";

const RegisterCustomerForm = () => {
    const user = useSelector((state: AppState) => state.user);
    const rawCategory = useSelector((state: AppState) => state.categories.category?.attributes?.slug);
    const category = CATEGORIES[rawCategory as keyof typeof CATEGORIES] || rawCategory || categoryOptions.app;
    const customerTrialEmailId = useSelector((state: AppState) => state.categories.category?.attributes?.customerTrialEmailId);
    const [username, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const regionCode = useSelector((state: AppState) => state.region?.code ?? "FI");
    const checkoutRegion = sessionStorage.getItem("confirmedBuyRegion");
    const [country, setCountry] = useState(checkoutRegion || regionCode);
    const countryOptions = checkoutRegion ? REGIONS.filter((r) => r.code === checkoutRegion) : REGIONS;
    const role = "customer";
    const [message, setMessage] = useState("");
    const [seniorHomeIds, setSeniorHomeIds] = useState(user.role === "head_nurse" ? user.supportStaff?.seniorHomeIds : "");
    const [btnDisabled, setBtnDisabled] = useState(true);
    let error = useSelector((state: AppState) => state.user.error);
    const selectedServices = useSelector((state: AppState) => state.cart.inCart);
    const history = useHistory();

    const [showPass, setShowPass] = useState(false);
    const showPassHandler = () => {
        setShowPass((current) => !current);
    };

    const dispatch = useDispatch();

    const seniorHomes = useSelector((state: AppState) => state.seniorHomes.list);
    const filteredHomes = seniorHomes;

    useEffect(() => {
        if (!username || !email || !password || !firstName || !lastName) {
            setBtnDisabled(true);
        } else {
            setBtnDisabled(false);
        }
        let msg = "";
        if (password.length > 0 && password.length < 11) {
            msg += "Salasana on liian lyhyt";
        }
        if (username.length > 0 && email.length > 0 && email !== username) {
            msg += "Sähköpostit eivät täsmää\n";
        }
        setMessage(msg);
    }, [username, email, password, firstName, lastName]);

    const getRedirectionRoute = () => {
        let redirect = null;

        if (user.isAdmin) {
            redirect = "/admin/users";
        } else if (category === categoryOptions.app) {
            redirect = localePath("tili", "seniori");
        } else if (selectedServices.length > 0) {
            redirect = localePath("toimitus");
        }
        return redirect;
    };

    const submitHandler = (e: React.FormEvent) => {
        e.preventDefault();
        if (password.length >= 11) {
            const redirect = getRedirectionRoute();

            const appOnly = category === categoryOptions.app && !history.location.pathname.includes("admin");

            dispatch(
                registerCustomerRequest(
                    username,
                    email,
                    password,
                    firstName,
                    lastName,
                    role,
                    appOnly,
                    history,
                    redirect,
                    Number(seniorHomeIds),
                    user.role === "head_nurse" || user.isAdmin,
                    phoneNumber,
                    appOnly ? customerTrialEmailId : undefined,
                    country,
                ),
            );
            // history.push('/kirjaudu')
            setUserName("");
            setEmail("");
            setPassword("");
            setFirstName("");
            setLastName("");
            setMessage("Kiitos, rekisteröinti onnistui.");
            setPhoneNumber("");
            setTimeout(() => {
                setMessage("");
                dispatch(clearUserError());
            }, 3000);
        }
    };

    const showPhoneField = category === categoryOptions.tablet || category === categoryOptions.app || category === categoryOptions.phone;

    return (
        <Container className="register-form-container">
            {category === categoryOptions.app && !user.isLoggedIn && (
                <InfoAccordion
                    buttonText="Kenen tili?"
                    title="TÄMÄ ON LÄHEISEN TILI, JOKA TILAA PALVELUN JA LISÄÄ SENIORIN JA MUUT LÄHEISET."
                    description="Poikkeustapauksessa, jos tilaat Digihappylta apin lisäksi tabletti- tai puhelinpalvelun, ja olet itse seniori, joka tekee tilauksen, tähän laitetaan seniorin omat tiedot."
                />
            )}
            {error && <Message variant="danger">{error}</Message>}
            {message && (
                <Message className="message" variant="danger">
                    {message}
                </Message>
            )}
            <Form onSubmit={submitHandler} className="register-form">
                <h1 className="register-header mb-4 text-center">Luo tili</h1>
                <Form.Group controlId="username-register">
                    <Form.Label>Sähköpostiosoite</Form.Label>
                    <Form.Control
                        type="email"
                        name="email"
                        placeholder="Sähköpostiosoite"
                        value={username}
                        onChange={(e) => {
                            setUserName(e.target.value);
                        }}
                    />
                </Form.Group>
                <Form.Group controlId="email-register">
                    <Form.Label>Toista sähköpostiosoite</Form.Label>
                    <Form.Control name="email" type="email" placeholder="Toista sähköpostiosoite" value={email} onChange={(e) => setEmail(e.target.value)} />
                </Form.Group>
                {showPhoneField && (
                    <Form.Group controlId="phoneNumber-register">
                        <Form.Label>Puhelin</Form.Label>
                        <Form.Control name="phoneNumber" type="tel" placeholder="+358" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                    </Form.Group>
                )}

                <Form.Group controlId="password-register">
                    <Form.Label>Salasana</Form.Label>
                    <InputGroup>
                        <Form.Control name="password" type={showPass ? "text" : "password"} placeholder="Salasana" value={password} onChange={(e) => setPassword(e.target.value)} />
                        <Button variant="outline-secondary shadow-none show-password-btn" onClick={showPassHandler}>
                            <i className={showPass ? "fas fa-eye-slash" : "fas fa-eye"}></i>
                        </Button>
                    </InputGroup>
                    <small className="password-length">Vähintään 11 merkkiä. Näet salasanasi klikkaamalla silmäkuvaketta</small>
                </Form.Group>
                <Form.Group as={Row}>
                    <Col sm={6}>
                        <Form.Label>Etunimi</Form.Label>
                        <Form.Control required type="text" name="firstName" placeholder="Etunimi" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                    </Col>
                    <Col sm={6}>
                        <Form.Label>Sukunimi</Form.Label>
                        <Form.Control required name="lastName" type="text" placeholder="Sukunimi" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                    </Col>
                </Form.Group>
                <Form.Group controlId="country-register">
                    <Form.Label>Maa</Form.Label>
                    <Form.Control as="select" name="country" value={country} onChange={(e) => setCountry(e.target.value)} disabled={!!checkoutRegion}>
                        {countryOptions.map((r) => (
                            <option key={r.code} value={r.code}>
                                {formatRegionOption(r)}
                            </option>
                        ))}
                    </Form.Control>
                </Form.Group>
                {(user.role === ROLE.HEAD_NURSE || user.isAdmin) && (
                    <Form.Group controlId="seniorHome">
                        <Form.Label>Yritys</Form.Label>
                        <Form.Control as="select" name="seniorHomeIds" onChange={(e) => setSeniorHomeIds(e.target.value)} value={String(seniorHomeIds)}>
                            <option value="">Valitse Yritys</option>
                            {(filteredHomes ?? []).map((seniorHome) => {
                                return (
                                    <option value={String(seniorHome.id)} key={String(seniorHome.id)}>
                                        {seniorHome.name}
                                    </option>
                                );
                            })}
                        </Form.Control>
                    </Form.Group>
                )}
                {user.role !== "head_nurse" && !user.isAdmin && (
                    <small className="terms-and-conditions">
                        Painamalla 'Tallenna' vahvistan hyväksyneeni{" "}
                        <Link to={localePath("palveluehdot")} target="_blank" className="conditions">
                            palvelun käyttöehdot
                        </Link>{" "}
                        ja{" "}
                        <Link to={localePath("copyright")} target="_blank" className="conditions">
                            tietosuojakäytännön
                        </Link>
                        .
                        <br />
                    </small>
                )}
                <Button className="register-button tallenna" type="submit" disabled={btnDisabled}>
                    Tallenna
                </Button>
                {user.role !== "head_nurse" && !user.isAdmin && (
                    <Row>
                        <Col className="forgot-password">
                            <Link className="forgot-password" to={localePath("kirjaudu")}>
                                Oletko jo rekisteröitynyt? Kirjaudu sisään
                            </Link>
                        </Col>
                    </Row>
                )}
            </Form>
        </Container>
    );
};

export default RegisterCustomerForm;
